'use client'

import {
  AlertCircleIcon,
  AlertTriangleIcon,
  CheckCircle2Icon,
  InfoIcon,
  LoaderIcon,
} from 'lucide-react'
import { useTheme } from 'next-themes'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      duration={3000}
      toastOptions={{
        classNames: {
          toast:
            'select-none border bg-background text-foreground shadow-lg border-border text-sans',
          title: 'leading-none',
          content: 'gap-1.5',
          description:
            'leading-none text-muted-foreground group-[.success]:text-success-text group-[.error]:text-critical-text group-[.warning]:text-warning-text group-[.info]:text-info-text',
          actionButton:
            'bg-primary text-primary-foreground hover:opacity-90 transition-opacity !duration-150',
          cancelButton: 'bg-muted text-muted-foreground',
          closeButton: 'h-full opacity-0 rounded-none transform-none w-full',

          success: 'bg-success-bg group success text-success-text-dark border-success-border ',
          error: 'bg-critical-bg group error text-critical-text-dark border-critical-border ',
          warning: 'bg-warning-bg group warning text-warning-text-dark border-warning-border ',
          info: 'bg-info-bg group info text-info-text-dark border-info-border ',
        },
      }}
      icons={{
        success: <CheckCircle2Icon className="text-success-text size-5" />,
        info: <InfoIcon className="text-info-text size-5" />,
        warning: <AlertTriangleIcon className="text-warning-text size-5" />,
        error: <AlertCircleIcon className="text-critical-text size-5" />,
        loading: <LoaderIcon className="text-foreground size-5" />,
      }}
      {...props}
    />
  )
}

export { Toaster }
